import { useState, useEffect } from 'react'
import PageHeader from '../../../components/common/PageHeader'
import { getUserInfo } from '../../../utils/token';
import { getCustomerUsageLastMsg } from '../../../api/endpoints/analytics';
import { format } from 'date-fns';
import DynamicTable from '../../../components/common/DynamicTable';

const CustomerUsage = () => {

  const [companyId, setCompanyId] = useState(null);
  const [rowList, setRowList] = useState([]);

  const columns = [
    { header: "Customer Name", accessor: "full_name",  render: (_, row) => `${row.customer_first_name} ${row.customer_last_name}` },
    { header: "Company Name", accessor: "customer_company_name"},
    {
      accessor: 'last_message_sent_at',
      header: 'Last Msg On',
      render: (value) => (
        <span>
          {value ? format(new Date(value), 'MMM dd, yyyy hh:mm a') : '-'}
        </span>
      ),
    },
  ];


  useEffect(()=>{
    const {userId} = getUserInfo();
    let compId = userId;
    setCompanyId(userId);
    
    async function fetchData() {
      const response  = await getCustomerUsageLastMsg(compId);
      const rawData = response.data?.data;
      console.log('Parsed Data:', rawData);
      console.log('Parsed Data:', typeof rawData);
      if (response.status === 200) {
        setRowList(rawData);
      } else {
        setRowList([]);
      }
    }
    fetchData();  
  },[]);

  return (
    <>
      <PageHeader  title="Customer Usage Report" breadcrumbs={[ {label: 'Reports'}, {label: 'Customer Usage Report'}]}/>
      <DynamicTable
        data={rowList}
        columns={columns}
        onTitle={"Customer Usage Report"}
        //search={search}
        //onSearchChange={(e) => setSearch(e.target.value)}
      />
    </>
  )
}

export default CustomerUsage